import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import { Identifier } from 'src/careflow/ph-core/fhir-client/resources';

const baseUrl = '/fhirutil';

export const getResourceUniqueIdentifierPayload = async (
  resourceType
): Promise<Identifier | null> => {
  try {
    const data = await apiClient.get<Identifier | null>(`${baseUrl}/resourceUniqueIdentifier`, {
      params: {
        resourceType,
      },
    });
    return data;
  } catch (error) {
    return null;
  }
};
